import axios from "axios";
import authHeader from "../services/auth-header";
import authenticationService from "../services/authentication.service";

const apiCall = {
  getAllJobList,
  getJobListBy,
  getJobDetails,
  getJobList,
  getApplicantList,
  getEmailVerifyStatus,
  getPresignedUrl,
  createJob,
  updateJob,
  deleteJobPost,
  postApplyJob,
  sendEmail,
  sendEmailVerification,
};

async function getAllJobList() {
  const getAllJobListAPIURL =
    process.env.REACT_APP_JOB_API_GET_ALL_JOB_LIST_URL;

  return axios.get(getAllJobListAPIURL, authHeader());
}

async function getJobListBy(queryParam) {
  const getJobListByAPIURL =
    process.env.REACT_APP_JOB_API_GET_JOB_LIST_BY_URL + "?" + queryParam;

  return axios.get(getJobListByAPIURL, authHeader());
}

async function getJobDetails(queryParam) {
  const getJobDetailsAPIURL =
    process.env.REACT_APP_JOB_API_GET_JOB_DETAILS_URL + "?" + queryParam;

  return axios.get(getJobDetailsAPIURL, authHeader());
}

async function getApplicantList() {
  const user = authenticationService.currentUser();

  if (!user) {
    return;
  }

  const getApplicantListAPIURL =
    process.env.REACT_APP_JOB_API_GET_APPLICANT_LIST_URL;

  const reqBody = {
    username: user.username,
  };

  return axios.post(getApplicantListAPIURL, reqBody, authHeader());
}

async function getEmailVerifyStatus() {
  const user = authenticationService.currentUser();

  if (!user) {
    return;
  }

  let queryParam = new URLSearchParams();
  queryParam.append("email", user.attributes.email);

  const getEmailVerifyStatusURL =
    process.env.REACT_APP_JOB_API_GET_EMAIL_VERIFY_STATUS_URL +
    "?" +
    queryParam.toString();

  return axios.get(getEmailVerifyStatusURL, authHeader());
}

async function getPresignedUrl(url) {
  const getPresignedAPIURL = process.env.REACT_APP_JOB_API_GET_PRESIGNED_URL;

  const reqBody = {
    fileUploadLocation: url,
  };

  return axios.post(getPresignedAPIURL, reqBody, authHeader());
}

async function getJobList() {
  const user = authenticationService.currentUser();

  if (!user) {
    return;
  }

  const getJobListAPIURL = process.env.REACT_APP_JOB_API_GET_JOB_LIST_URL;

  const reqBody = {
    username: user.username,
  };

  return axios.post(getJobListAPIURL, reqBody, authHeader());
}

async function createJob(reqBody) {
  const createJobAPIURL = process.env.REACT_APP_JOB_API_CREATE_JOB_URL;

  return axios.post(createJobAPIURL, reqBody, authHeader());
}

async function updateJob(reqBody) {
  const updateJobAPIURL = process.env.REACT_APP_JOB_API_UPDATE_JOB_URL;

  return axios.post(updateJobAPIURL, reqBody, authHeader());
}

async function deleteJobPost(reqBody) {
  const deleteJobPostAPIURL = process.env.REACT_APP_JOB_API_DELETE_JOB_POST_URL;

  const { headers } = authHeader();

  return axios.delete(deleteJobPostAPIURL, {
    headers,
    data: reqBody,
  });
}

async function postApplyJob(reqBody) {
  const createJobAPIURL = process.env.REACT_APP_JOB_API_CREATE_APPLY_JOB;

  return axios.post(createJobAPIURL, reqBody, authHeader());
}

async function sendEmail(reqBody) {
  const sendEmailAPIURL = process.env.REACT_APP_JOB_API_SEND_EMAIL_URL;

  return axios.post(sendEmailAPIURL, reqBody, authHeader());
}

async function sendEmailVerification(reqBody) {
  const sendEmailVerificationAPIURL =
    process.env.REACT_APP_JOB_API_SEND_EMAIL_VERIFICATION_URL;

  return axios.post(sendEmailVerificationAPIURL, reqBody, authHeader());
}

export default apiCall;
